import { MarkType } from "#app/utils/domain/types";
import Chip from "../ui/chip";

export default function MarkChip({
  id,
  markType,
  textContent,
  pageNumber,
}: {
  id: string;
  markType: string;
  textContent: string;
  pageNumber: number | null;
}) {
  return (
    <Chip
      text={`${pageNumber ? `[p. ${pageNumber}] ` : ""}${textContent}`}
      linkTo={`/marks/edit/${markType}/${id}`}
      expandedStyle={true}
      altLinkStyle={markType === MarkType.NOTE}
      className="mb-1 font-serif"
    />
  );
}
